module.exports = __webpack_public_path__ + "img/point_setting.8f6eaa99.png";